import React from 'react';
import MuiDialogContent from '@mui/material/DialogContent';

const DialogContent = (props) => <MuiDialogContent {...props} />;

export default DialogContent;
